/**
 * Generates action creators
 *
 * So this:
 *
 * function fetchDonutLegendSuccess (arg1, arg2) {
 *  return {
 *    type: 'FETCH_DONUT_LEGEND_SUCCESS',
 *    arg1,
 *    arg2,
 *  };
 * }
 *
 * becomes:
 *
 * const fetchDonutLegendSuccess = makeActionCreator('FETCH_DONUT_LEGEND_SUCCESS', 'arg1', 'arg2');
 *
 * @param type The name of the action
 * @param argNames Any arguments passed to the action as a payload
 * @returns {function(...[*]): {type: *}}
 */
export default function makeActionCreator (type, ...argNames) {
  return function (...args) {
    const action = { type };
    argNames.forEach((arg, index) => {
      action[argNames[index]] = args[index];
    });
    return action;
  };
}
